import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export class NumberValidator {
    // validates that the field has a length of exactly the choosen length
    public static digits(length): ValidatorFn {
        const fn = (control: AbstractControl): ValidationErrors | null => {
            if (!control.value) {
                return;
            }
            return control.value.length !== length ? { 'length': length } : null;
        };

        return fn;
    }

    public static isNumber(): ValidatorFn {
        const fn = (control: AbstractControl): ValidationErrors | null => {
            if (!control.value) {
                return;
            }
            return isNaN(control.value) ? { 'number': true } : null;
        };

        return fn;
    }
}
